// import ModalForm from "./Form";
import AssignScheduleTableForm from "./AssignScheduleTableForm";
import AssignScheduleSecondForm from "./AssignScheduleSecondForm";
import {
	ASSIGN_SCHEDULE,
	DATATABLE_EXPORT,
} from "../../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../../Config/ApiUrl";

export const AssignScheduleTableSchema = {
	components: { AssignScheduleTableForm, AssignScheduleSecondForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			isAddEditSecondModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint:
				ASSIGN_SCHEDULE + "?clc_id_number=" + this.value.clc_id_number,
			tableId: "assign-schedule-table",
			formId: "assign-schedule-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "Reference ID",
					type: "custom-html",
					key: "invoice_id",
					modifier: (value) => {
						if (value) {
							return value.invoice_no ?? value.request_no;
						} else {
							return "";
						}
					},
				},
				{
					title: "Product Name",
					type: "custom-html",
					key: "product_id",
					modifier: (value) => {
						return value.name;
					},
				},
				{
					title: "Placement Date",
					type: "custom-html",
					key: "placement_id",
					modifier: (value) => {
						return value.placement_date_formatted;
					},
				},
				{
					title: "Schedule",
					type: "action",
				},
				{
					title: "Recommended By",
					type: "custom-html",
					key: "recommended_by",
					modifier: (value) => {
						return value ? value.full_name : "";
					},
				},
				{
					title: "Date",
					type: "text",
					key: "assign_schedule_date",
				},
				{
					title: "Note",
					type: "text",
					key: "note",
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action2",
			},
			options: {
				name: "AssignScheduleTable",
				url:
					ASSIGN_SCHEDULE +
					"?clc_id_number=" +
					this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("view"),
						icon: "eye",
						type: "viewAndHideAssignSchedule",
					},
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "modal",
						component: "assign-schedule-table-form",
						modalId: "assign-schedule-table-form",
					},
					{
						title: this.$t("add schedule"),
						icon: "plus",
						type: "modal",
						component: "assign-schedule-second-form",
						modalId: "assign-schedule-second-form",
						// disabled: (rowData) => this.isAddScheduleDisabled(rowData),
					},
				],
				actions2: [
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
						disabled: (rowData) =>
							this.isAssignScheduleDeleteDisabled(rowData),
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		isAddScheduleDisabled(rowData) {
			return rowData.schedule_recommendation.length > 0;
		},
		isAssignScheduleDeleteDisabled(rowData) {
			if (rowData.invoice_id) {
				return rowData.invoice_id.status.toLowerCase() === "processed"
					? true
					: false;
			} else {
				return false;
			}
		},
	},
};
